import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

export default () => {

    const data = useStaticQuery(graphql`
        query {
            wpMenu(locations: { eq: FOOTER_MENU }) {
                id
                name
                menuItems {
                    nodes {
                        id
                        label
                        path
                        parentDatabaseId
                        target
                        connectedNode {
                            node {
                                ... on WpPost {
                                    isContentNode
                                }
                            }
                        }
                        childItems {
                            nodes {
                                id
                                label
                                path
                                parentDatabaseId
                                target
                                connectedNode {
                                    node {
                                        ... on WpPost {
                                            isContentNode
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `)
    return (

        <nav className="pb-12 border-b border-white">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 lg:gap-12 footer-nav">
                {data &&
                    data.wpMenu &&
                    data.wpMenu.menuItems &&
                    data.wpMenu.menuItems.nodes &&
                    data.wpMenu.menuItems.nodes.map(
                        (prop, index) => {

                            if (prop.parentDatabaseId === 0 && prop.childItems.nodes.length > 0) {

                                return (
                                    <ul key={index} className="m-0 footer-nav-list">
                                        <li key={prop.id}>
                                            <Link className="text-white no-underline font-normal" to={prop.path} title={'Rekord Fenster | ' + prop.label}>{prop.label}</Link>
                                        </li>
                                        {prop && prop.childItems && prop.childItems.nodes.map(child => {

                                            if (child.connectedNode !== null && child.connectedNode.node && child.connectedNode.node.isContentNode) {
                                                var url = '/ratgeber' + child.url
                                            } else {
                                                var url = child.url
                                            }

                                            return (
                                                <li key={child.id}>
                                                    <Link className="text-white no-underline font-normal" to={child.path} title={'Rekord Fenster | ' + child.label} target={prop.target}>{child.label}</Link>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                )

                            } else if (prop.parentDatabaseId === 0 && prop.childItems.nodes.length === 0) {

                                return (
                                    <ul key={index} className="m-0 footer-nav-list">
                                        <li key={prop.id}>
                                            <Link className="text-white no-underline font-normal" to={prop.path} title={'Rekord Fenster | ' + prop.label} target={prop.target}>{prop.label}</Link>
                                        </li>
                                    </ul>
                                )
                            }

                        }
                    )
                }
                <div className="pt-4">
                    <img width={326} height={230} className="w-full h-auto" src={'/guetesiegel.webp'} alt="Rekord Fenster Test Sieger Preis-Leistung 2025" />
                </div>
                <div className="pt-4">
                    <img width={326} height={230} className="w-full h-auto" src={'/leva-winner-2025-logo.webp'} alt="Rekord Fenster Leva Winner 2025" />
                </div>
            </div>
        </nav>

    )

}
